{
  "name": "client",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c dev-edge",
    "local-cloud": "ng serve -c local-cloud --proxy-config proxy.conf.json",
    "local-cypress": "ng serve -c local-cloud --proxy-config proxy.conf.json --host 0.0.0.0",
    "local-edge": "ng serve -c local-edge --proxy-config proxy.conf.json",
    "dev-cloud": "ng serve -c dev-cloud",
    "dev-edge": "ng serve -c dev-edge",
    "prod-cloud": "ng serve -c prod-cloud",
    "prod-edge": "ng serve -c prod-edge",
    "demo": "ng serve -c demo",
    "client": "ng serve -c client",
    "build": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production -c dev-edge",
    "build-cloud": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production -c dev-cloud",
    "test": "jest --silent --forceExit",
    "test:ci": "jest --silent --reporters=jest-junit --forceExit",
    "lint": "ng lint",
    "eslint": "eslint src/**/*.ts",
    "e2e": "ng e2e",
    "coverage": "jest --coverage",
    "build-electron": "ng build -c electron --base-href ./ --output-path ./../../electron/application/OPS/client",
    "prettier": "prettier --write 'src/**/*.ts'"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.1.4",
    "@angular/common": "19.1.4",
    "@angular/compiler": "^19.1.4",
    "@angular/core": "19.1.4",
    "@angular/forms": "19.1.4",
    "@angular/material": "^19.1.2",
    "@angular/platform-browser": "19.1.4",
    "@angular/platform-browser-dynamic": "19.1.4",
    "@angular/router": "19.1.4",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@svgdotjs/svg.js": "^3.2.0",
    "dayjs": "^1.11.10",
    "decimal.js": "^10.4.3",
    "dom-to-image": "^2.6.0",
    "dygraphs": "^2.2.1",
    "echarts": "^5.5.0",
    "echarts-for-angular": "^0.4.0",
    "file-saver": "^2.0.5",
    "jest-junit": "^16.0.0",
    "lodash": "^4.17.21",
    "lodash.range": "^3.2.0",
    "mimic-viewer": "file:../mimic-viewer-pack/mimic-viewer-0.0.3.tgz",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^16.2.0",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.3.0",
    "uuid": "^10.0.0",
    "validator": "^13.12.0",
    "yup": "^1.6.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^19.1.5",
    "@angular/cli": "19.1.5",
    "@angular/compiler-cli": "19.1.4",
    "@types/jest": "^29.5.12",
    "@types/lodash": "^4.17.0",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.0.3",
    "ng-mocks": "^14.12.1",
    "prettier": "^3.2.5",
    "ts-jest": "^29.1.2",
    "typescript": "^5.5.4"
  }
}
